import { BulkPostHeader } from 'src/pages/scheduledPost/Grid/BulkPostDelete';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UserListHead } from 'src/sections/@dashboard/user';

const FailedPostGridHead = ({ failedPostList, order, orderBy, handleRequestSort }) => {
  const { t: translate } = useTranslation();
  const getTableDesk = [
    { id: 'drop_down', width: 40, label: '', alignCenter: true },
    { id: 'scheduled_time', label: translate('approval.tab.scheduled_time'), alignRight: false, hasSort: true },
    { id: 'created_time', label: translate('approval.tab.created_time'), alignRight: false, hasSort: true },
    { id: 'updated_at', label: translate('approval.tab.updated_at'), alignRight: false, hasSort: true },
    { id: 'description', label: translate('approval.tab.post_content'), alignRight: false, hasSort: true },
    { id: 'media', label: translate('approval.tab.media'), alignRight: false },
    { id: 'created_by_name', label: translate('approval.tab.created_by'), alignRight: false, hasSort: true },
    { id: 'approved_by_name', label: translate('upcoming_post.approved_by'), alignRight: false, hasSort: true },
    { id: 'scheduled-for', label: translate('approval.tab.scheduled_for'), alignRight: false },
    { id: 'action', label: translate('approval.tab.action'), alignCenter: true },
  ];
  const getTableMobile = [
    { id: 'drop_down', width: 40, label: '', alignCenter: true },
    { id: 'scheduled-on', label: translate('approval.tab.scheduled_time'), alignRight: false, hasSort: true },
    { id: 'post-content', label: translate('approval.tab.post_content'), alignRight: false, hasSort: true },
    { id: 'action', label: translate('approval.tab.action'), alignRight: false },
  ];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const TABLE_HEAD = isMobile ? getTableMobile : getTableDesk;

  return (
    <UserListHead
      order={order}
      orderBy={orderBy}
      headLabel={[{ id: 'bulk_selection', width: 48, alignCenter: true, label: <BulkPostHeader /> }, ...TABLE_HEAD]}
      rowCount={failedPostList.length}
      onRequestSort={handleRequestSort}
      style={{ whiteSpace: 'nowrap' }}
      isShowCheckbox={false}
    />
  );
};

export default FailedPostGridHead;
